import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Program {
  id: number;
  user_id: number;
  name: string;
  slug: string;
  archive_status: number;
  last_event: number;
  live_last_event: number;
  plan: number;
  android_stream_url: string;
  public_hls: string;
  public_image_url: string;
  public_url: string;
  stream_key?: string;
  stream_url?: string;
  created_at: string;
  updated_at: string;
}

export interface ProgramsInfo {
  programData: Program;
}

@Module
export default class ProgramModule extends VuexModule implements ProgramsInfo {
  programData = {} as Program;

  get program(): Program {
    return this.programData;
  }

  @Mutation
  [Mutations.SET_PROGRAM](payload) {
    this.programData = payload;
  }

  @Action
  [Actions.FETCH_PROGRAM](slug) {
    const params = { slug: slug };
    return new Promise<void>((resolve, reject) => {
      ApiService.query("public/v2/assets", {
        params: params,
      })
        .then(({ data }) => {
          this.context.commit(Mutations.SET_PROGRAM, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
}
